import { attribute } from './attribute';
import { input } from './input';
import { output } from './output';
import { witness } from './witness';
export const converters = {
    attribute,
    input,
    output,
    witness,
};

//# sourceMappingURL=index.js.map
